import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useUserCarsStore = defineStore('user-cars', () => {

    const configStore = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore = useTokenStore()

    const userCars = ref({})
    const userCarsProcess = ref(false)
    const userCarsMsg = ref({})

    const userCarsCreateList = ref({})
    const userCarsCreateListProcess = ref(false)
    const userCarsCreateListMsg = ref({})

    const userCarsCreateProcess = ref(false)
    const userCarsCreateMsg = ref({})

    const userCarsDeleteProcess = ref(false)
    const userCarsDeleteMsg = ref({})

    async function createUserCars(payload) {

        userCarsCreateProcess.value = true
        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/links/cars`, 
                method: 'POST', 
                token,
                data: payload
            })

            if(!request.error) {
                userCarsCreateMsg.value = { success: true, text: 'USER_CARS_CREATE_SUCCESS' }
            } else {
                userCarsCreateMsg.value = { success: false, text: request.error }
            }

        } else {
            userCarsCreateMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userCarsCreateProcess.value = false
    }

    async function readUserCars(payload) {

        userCarsProcess.value = true
        const token = tokenStore.access

        if(token) {

            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars${params}`, 
                method: 'GET', 
                token
            })  

            if(!request.error) {
                if(request.error) {
                    userCars.value = {}
                    userCarsMsg.value = { success: false, text: 'CARS_GROUP_CARS_EMPTY' }
                } else {
                    userCars.value = request
                    userCarsMsg.value = { success: true }
                }
            } else {
                userCars.value = {}
                userCarsMsg.value = { success: false, text: request.error }
            }

        } else {

            userCarsMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userCarsProcess.value = false
        return userCars.value
    }

    async function readUserCarsCreateList(payload) {

        userCarsCreateListProcess.value = true
        const token = tokenStore.access

        if(token) {
            let params = ''
            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }
            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/cars${params}`, 
                method: 'GET', 
                token
            })
            if(!request.error && request.array?.length) {
                userCarsCreateList.value = request
                userCarsCreateListMsg.value = { success: true }
            } else {
                userCarsCreateList.value = {}
                userCarsCreateListMsg.value = { success: false, text: request.error }
            }

        } else {
            userCarsCreateListMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userCarsCreateListProcess.value = false
        return userCarsCreateList.value
    }

    async function deleteUserCars(payload) {

        userCarsDeleteProcess.value = true
        const token = tokenStore.access

        if(token) {
        
            let params = ''

            if(payload) {
                for( let param in payload) {
                    params.length ?
                        params += '&' + param + '=' + payload[param] :
                        params = '?' + param + '=' + payload[param]
                }
            }

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/users/links/cars${params}`, 
                method: 'DELETE', 
                token
            })

            if(!request.error) {
                userCarsDeleteMsg.value = { success: true, text: 'USER_CARS_DELETE_SUCCESS' }
            } else {
                userCarsDeleteMsg.value = { success: false, text: request.error }
            }

        } else {
            userCarsDeleteMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        userCarsDeleteProcess.value = false
    }

    const setUserCarsMsg              = data => userCarsMsg.value       = data
    const setUserCarsCreateMsg        = data => userCarsCreateMsg.value = data
    const setUserCarsDeleteMsg        = data => userCarsDeleteMsg.value = data
    const setUserCarsCreateListMsg    = data => userCarsCreateListMsg.value = data

    return {

        userCars,
        userCarsProcess,
        userCarsMsg,
        userCarsCreateList,
        userCarsCreateListMsg,
        userCarsCreateProcess,
        userCarsCreateMsg,
        userCarsDeleteProcess,
        userCarsDeleteMsg,
        createUserCars,
        readUserCars,
        readUserCarsCreateList,
        deleteUserCars,
        setUserCarsMsg,
        setUserCarsCreateMsg,
        setUserCarsDeleteMsg, 
        setUserCarsCreateListMsg
    }
})
